import { IPublicClientApplication, SilentRequest } from '@azure/msal-browser';
import { redirectRequest } from '../configurations';

export const getAccessToken = async (
  instance: IPublicClientApplication,
  scopes: string[],
): Promise<string | undefined> => {
  const silentRequest: SilentRequest = {
    scopes,
  };

  try {
    const tokenResponse = await instance.acquireTokenSilent(silentRequest);
    return tokenResponse.accessToken;
  } catch (error) {
    await instance.acquireTokenRedirect(redirectRequest);
    return undefined;
  }
};
